/**
 * Created by Karol Kluska on 06.09.17.
 */
angular
    .module('app')
    .directive('stylesheet', function () {
      return {
        restrict: 'E',
        link: link,
        scope: {
          css: '=css'
        }
      };

      function link(scope) {
        var css = scope.css || '';
        var html = '<style type="text/css">' + css + '</style>';
        angular.element(html).appendTo(angular.element('head'));
      }
    });
